<template>
  <div>
    <div class="row">
      <div style="margin-top: -35px" class="col-8">
        <div>
          <div v-if="this.itemPolicyType === 1">
            <span style="font-size:14pt">{{$t('İşçilik')}}</span>
            <el-table border :summary-method="getSummariesRepair" show-summary v-loading="repairLoading" :data="repairStages.filter(
              (data) =>
                !search ||
                data.stageName
                  .toLowerCase()
                  .includes(search.toLowerCase())
            )
              " style="width: 100%;">
              <el-table-column :label="$t('Mərhələ')" prop="stageName" width="250">
              </el-table-column>
              <el-table-column :label="$t('Məbləğ')" prop="price" width="250">
              </el-table-column>
              <el-table-column :label="$t('Qeyd')" prop="notes">
              </el-table-column>

              <el-table-column align="right" v-if="!readonly" fixed="right" width="45">
                <template slot="header"> </template>
                <template slot-scope="scope">
                  <el-dropdown trigger="click" @command="handleCommandRep">
                    <el-button type="text" class="custom-button" style="padding: 0 10px 0 0 !important;">
                      <div class="square-icon">
                        <i class="fas fa-ellipsis-h" :title="$t('Düzəliş_vəya_ləğv')" style="color: #808080;"></i>
                      </div>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{ action: 'edit', row: scope.row }">
                        <i class="fa-solid fa-pen-to-square"></i>{{$t('Düzəliş')}}
                      </el-dropdown-item>
                      <el-dropdown-item :command="{ action: 'delete', row: scope.row }">
                        <i class="fa-solid fa-trash-can"></i>{{$t('Ləğv_et')}}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          
          <br>
          <span style="font-size:14pt">{{$t(itemPolicyType === 1 ? 'Ehtiyyat_hissələri' : 'Zərər_dəymiş_hissələr')}}</span>

          <el-table border :summary-method="getSummariesSpare" show-summary v-loading="spareLoading" :data="spareParts.filter(
            (data) =>
              !search ||
              data.stageName
                .toLowerCase()
                .includes(search.toLowerCase())
          )
            " style="width: 100%">
            <el-table-column :label="$t(itemPolicyType === 1 ? 'Ehtiyyat_hissələri' : 'Zərər_dəymiş_hissələr')" prop="partName">
            </el-table-column>
            <el-table-column :label="$t('Say')" prop="count" width="80">
            </el-table-column>
            <el-table-column :label="$t('Məbləğ')" prop="price" width="80">
            </el-table-column>
            <el-table-column :label="$t('Cəm')" prop="priceSum" width="80">
            </el-table-column>
            <el-table-column align="right" fixed="right" v-if="!readonly" width="45">
              <template slot="header"> </template>
              <template slot-scope="scope">
                <el-dropdown trigger="click" @command="handleCommandSpare">
                  <el-button type="text" class="custom-button" style="padding: 0 10px 0 0 !important;">
                    <div class="square-icon">
                      <i class="fas fa-ellipsis-h" :title="$t('Düzəliş_vəya_ləğv')" style="color: #808080;"></i>
                    </div>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{ action: 'edit', row: scope.row }">
                      <i class="fa-solid fa-pen-to-square"></i>{{$t('Düzəliş')}}
                    </el-dropdown-item>
                    <el-dropdown-item :command="{ action: 'delete', row: scope.row }">
                      <i class="fa-solid fa-trash-can"></i>{{$t('Ləğv_et')}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <br>
          <div :style="readonly ? 'margin-top:8px' : ''">
            <span style="font-size:13pt;font-weight:bold">{{$t('Ümumi_məbləğ')}} :</span>
            <span style="font-size:13pt;"> {{ this.totalSum }}</span>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div v-if="!readonly">
          <el-form style="margin-top: 10px" size="small">
            <el-form-item :label="$t('İşin_növü')" prop="type">
              <el-select style="width: 100%" size="small" v-model="type">
                <el-option :label="$t('İşçilik')" v-show="this.itemPolicyType === 1" :value="1"></el-option>
                <el-option :label="$t(itemPolicyType === 1 ? 'Ehtiyyat_hissələri' : 'Zərər_dəymiş_hissələr')" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div v-show="type == 1">
            <el-form :model="repairItem" ref="repair" size="small" :rules="rulesRepair">
              <el-form-item :label="$t('Mərhələ')" prop="stageId">
                <stages v-model="repairItem.stageId"></stages>
              </el-form-item>
              <el-form-item :label="$t('Məbləğ')" prop="price">
                <el-input v-decimal v-model="repairItem.price"></el-input>
              </el-form-item>
              <el-form-item :label="$t('Qeyd')" prop="notes">
                <el-input resize="none" type="textarea" :rows="2" v-model="repairItem.notes"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div v-show="type == 2">
            <el-form ref="spare" :label-position="labelPosition" @keyup.enter.native="clickSparePartSave" :model="spareItem" :rules="rulesSpare"
              size="small">
              <el-form-item :label="$t(itemPolicyType === 1 ? 'Ehtiyyat_hissələri' : 'Zərər_dəymiş_hissə')" prop="partName">
                <el-input ref="partNameInput" resize="none" type="textarea" :rows="3"
                  v-model="spareItem.partName"></el-input>
              </el-form-item>
              <el-form-item :label="$t('Məbləğ')" prop="price">
                <el-input v-decimal v-model="spareItem.price"></el-input>
              </el-form-item>
              <el-form-item :label="$t('Say')" prop="count">
                <el-input type="number" v-model="spareItem.count"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>

        <div>
          <el-button type="primary" size="small" v-if="!readonly"
            @click="type == 1 ? clickRepairStageSave() : clickSparePartSave()">
            &nbsp;{{$t('Yadda_saxla')}} &nbsp;
          </el-button>
          <el-button size="small" style="margin-bottom: 10px;" id="button" @click="print" v-print="'printMe'" type="success">
            <i class="fa-solid fa-print"></i> &nbsp;{{$t('Çap_et')}}
          </el-button>
          <el-button size="small" style="margin-bottom: 10px;" @click="showPdf" type="warning">
            <i class="fa-solid fa-file-pdf"></i> &nbsp;{{$t('Yüklə')}}
          </el-button>
        </div>
      </div>
    </div>
    <div v-show="false">
      <div ref="printRef" id="printMe">
        <damage-act-print :repair="repairStages" :spare="spareParts" :victim="victimParticipant" :policyType="this.itemPolicyType"
          :total="this.totalSum"></damage-act-print>
      </div>
    </div>
  </div>
</template>

<script>
import Stages from "../components/Stages.vue";
import DamageActPrint from "./DamageActPrint.vue";
import { api,labelPosition } from "../../services/helper";
import html2pdf from "html2pdf.js";
import html2canvas from 'html2canvas';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import { RepairStageType, SparePartType } from "../../services/types";
import { GetVictimParticipant } from "../../services/accident";
import { EventBus } from '../../services/eventbus';
import {
  GetRepairStages,
  CreateRepairStage,
  UpdateRepairStage,
  DeleteRepairStage,
  GetSpareParts,
  CreateSparePart,
  UpdateSparePart,
  DeleteSparePart,
  RepairStagesTotalSum
} from "../../services/common";
export default {

  components: { Stages, DamageActPrint },
  props: {
    value: { type: Number, default: 0 },
    readonly: { type: Boolean, default: false },
    actType: { type: Number, default: 1 },
    policyType: { type: Number, default: 1 },
  },
  data() {
    return {
      claimId: this.value,
      itemActType: this.actType,
      itemPolicyType: this.policyType,
      spareLoading: false,
      repairLoading: false,
      repairStages: [],
      spareParts: [],
      search: "",
      repairItem: {},
      spareItem: {},
      victimParticipant: {},
      type: 2,
      tableWit: '300',
      printPage: true,
      totalSum: 0.00,
      uid: this.$store.state.user.id,
      labelPosition: labelPosition,
    };
  },
  computed: {
    rulesRepair() {
      return {
        price: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        stageId: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
      }
    },
    rulesSpare() {
      return {
        partName: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        price: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        count: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
      }
    },
  },
  // created() {
  //   EventBus.$on('save-event', this.convertToPDFAndSave); // parantezleri kaldırın
  // },
  // beforeDestroy() {
  //   EventBus.$off('save-event', this.convertToPDFAndSave); // parantezleri kaldırın
  // },

  methods: {

    // convertToPDFAndSave() {
    //   let element = document.getElementById('printMe');
    //   let opt = {
    //     margin: 10,
    //     filename: 'myfile.pdf',
    //     image: { type: 'jpeg', quality: 0.98 },
    //     html2canvas: { scale: 5 },
    //     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    //   };
    //   html2pdf().from(element).set(opt).outputPdf().then(pdfData => {
    //     // 2. PDF verisini sunucuya yükleme
    //     uploadPDF(pdfData);
    //   });
    //   function uploadPDF(pdfData) {
    //     let formData = new FormData();
    //     formData.append("file", new Blob([pdfData], { type: "application/pdf" }), "dosyaAdi.pdf");

    //     fetch(api + '/Upload', {
    //       method: 'POST',
    //       headers: {
    //         'Accept': 'application/json'
    //       },
    //       body: formData
    //     })
    //       .then(response => {
    //         if (!response.ok) {
    //           throw new Error('Network response was not ok');
    //         }
    //         return response.json();
    //       })
    //       .then(data => {
    //         console.log(data);
    //       })
    //       .catch(error => {
    //         console.log('Upload error:', error);
    //       });
    //   }

    // },

    //     async  convertToPDFAndSave() {
    //   // Öncelikle ekran görüntüsü al
    //   let canvas = await html2canvas(document.body);  // Burada tüm sayfanın ekran görüntüsü alınıyor. Farklı bir element almak isterseniz, document.body kısmını değiştirin.

    //   // Canvas'ı bir görüntüye dönüştür
    //   let imgData = canvas.toDataURL('image/png');

    //   // FormData oluştur
    //   let formData = new FormData();
    //   let blob = await (await fetch(imgData)).blob();
    //   formData.append("file", blob, "screenshot.png");  // "screenshot.png" ekran görüntüsünün adıdır. İsterseniz değiştirebilirsiniz.

    //   // Sunucuya gönder
    //   try {
    //     const response = await fetch(api + '/Upload', {
    //       method: 'POST',
    //       headers: {
    //         'Accept': 'application/png'
    //       },
    //       body: formData
    //     });

    //     if (response.ok) {
    //       console.log('Screenshot uploaded successfully!');
    //     } else {
    //       console.error('Error uploading screenshot:', await response.text());
    //     }
    //   } catch (error) {
    //     console.error('Error uploading screenshot:', error);
    //   }
    // },


    showPdf() {
      let content = this.$refs.printRef;

      let opt = {
        margin: 1,
        filename: 'desiredFileName.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2 },
      };

      let pdfOutput = html2pdf().from(content).output('blob', opt);

      pdfOutput.then(pdfBlob => {
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
      });
    },


    convertToPDFAndSave() {
      let content = this.$refs.printRef;

      let opt = {
        margin: 1,
        filename: 'desiredFileName.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2 },
      };

      let pdfOutput = html2pdf().from(content).outputPdf(opt);

      let formData = new FormData();
      formData.append("file", new Blob([pdfOutput], { type: 'application/pdf' }), "desiredFileName.pdf");

      fetch(api + '/Upload', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
        })
        .catch(error => {
        });
    },



    async updateTableData() {
     await this.getRepairStages();
     await this.getSpareParts();
    },

    getVictimParticipant() {
      this.loading = true;
      GetVictimParticipant(this.claimId).then((response) => {
        this.loading = false;
        if (response.data.data) {
          console.log(response.data.data)
          this.victimParticipant = response.data.data;
        } else {
          this.victimParticipant = {};
        }
      });
    },



    resetRepairForm() {
      this.repairItem.id = null;
      this.repairItem.stageId = null;
      this.repairItem.notes = "";
      this.repairItem.price = null;
    },
    print() {
      this.printPage = false
    },
    resetSpareForm() {
      this.spareItem.id = null
      this.spareItem.partName = null;
      this.spareItem.price = null;
    },
    repairStagesTotalSum() {
      RepairStagesTotalSum(this.value, this.itemActType).then((response) => {
        if (response.data != null) {
          this.totalSum = response.data;
          if (this.itemActType === 1)
            this.$emit('initialSum', this.totalSum)
          else
            this.$emit('finishSum', this.totalSum)
        } else {
          this.$message({
            type: "warning",
            message: "Səhv əməliyyat",
          });
        }
      });
    },
    getSummariesSpare(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Cəmi';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += '';
        } else {
        }
      });

      return sums;
    },
    getSummariesRepair(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = index === 1 ? '' : 'Cəmi';
          return;
        }
        if (index === 1) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          }
        } else {
          sums[index] = ''; // Diğer sütunlar için boş değer ekleyin
        }
      });
      return sums;
    },

    getRepairStages() {
      GetRepairStages(this.value, this.itemActType).then((response) => {
        if (response.data.data) {
          this.repairStages = response.data.data;
           console.log(response.data.data)
          this.repairStagesTotalSum();
        } else {
          this.$message({
            type: "warning",
            message: "Səhv əməliyyat",
          });
        }
      });
    },

    clickRepairStageSave() {
      this.$refs["repair"].validate((valid) => {
        if (!valid) {
          this.$message({
            type: "warning",
            message: "Məlumatların tam və düzgün olmasını yoxlayın",
          });
          return false;
        }
        else {
          let rep = Object.assign({}, this.repairItem);
          this.repairLoading = true;
          rep.claimId = this.value;
          rep.commandUserId = this.uid;
          rep.actType = this.itemActType;
          if (!rep.id) {
            CreateRepairStage(rep).then(
              (response) => {
                if (response.data) {
                  if (!response.data.isSuccess) {
                    this.$message({
                      type: "error",
                      message: "Səhv əməliyyat"
                        ? "Səhv əməliyyat"
                        : "Səhv əməliyyat",
                    });
                  } else {
                    this.$message({
                      type: "success",
                      message: "Uğurlu əməliyyat",
                    });
                    this.repairLoading = false;
                    this.getRepairStages();
                    this.resetRepairForm();
                  }
                } else {
                  this.$message({
                    type: "error",
                    message: "Səhv əməliyyat",
                  });
                }
              }
            );
          } else {
            UpdateRepairStage(rep).then((response) => {
              this.repairLoading = false;
              if (response.data.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: "Səhv əməliyyat",
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "Uğurlu əməliyyat",
                  });
                  this.getRepairStages();
                  this.resetRepairForm();
                }
              } else {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              }
            });
          }
        }
      });
    },

    handleCommandRep(command) {
      let row = command.row;
      if (command.action === "delete") this.handleRepDelete(row.id);
      else if (command.action === "edit") this.handleRepEdit(row);
    },
    handleRepEdit(row) {
      this.type = 1;
      this.repairItem.id = row.id
      this.repairItem.stageId = row.stageId
      this.repairItem.price = row.price
      this.repairItem.notes = row.notes
    },
    handleRepDelete(id) {
      this.$confirm("Mərhələ ləğv olunsun?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
        type: "error",
      })
        .then(() => {
          this.repairLoading = true;
          DeleteRepairStage(id, this.value, this.uid, this.itemActType).then((response) => {
            this.repairLoading = false;
            if (response.data.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "Ləğv olundu",
                });
                this.getRepairStages();
              }
            } else {
              this.$message({
                type: "error",
                message: "Səhv əməliyyat",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Xitam verildi",
          });
        });
    },
    getSpareParts() {
      GetSpareParts(this.value, this.itemActType).then((response) => {
        if (response.data.data) {
          this.spareParts = response.data.data;
           console.log(response.data.data)
          this.repairStagesTotalSum();
        } else {
          this.$message({
            type: "warning",
            message: "Səhv əməliyyat",
          });
        }
      });
    },

    clickSparePartSave() {

      this.$refs["spare"].validate((valid) => {
        if (!valid) {
          this.$message({
            type: "warning",
            message: "Məlumatların tam və düzgün olmasını yoxlayın",
          });
          return false;
        }
        else {
          let spare = Object.assign({}, this.spareItem);
          this.spareLoading = true;
          spare.claimId = this.value;
          spare.commandUserId = this.uid;
          spare.actType = this.itemActType;
          if (!spare.id) {
            CreateSparePart(spare).then(
              (response) => {
                this.spareLoading = false;
                if (response.data) {
                  if (!response.data.isSuccess) {
                    alert("123")
                    this.$message({
                      type: "error",
                      message: "Səhv əməliyyat"
                        ? "Səhv əməliyyaet"
                        : "Səhv əməliyyat",
                    });
                  } else {
                    this.showModal = false;
                    this.$message({
                      type: "success",
                      message: "Uğurlu əməliyyat",
                    });
                    this.getSpareParts();
                    this.resetSpareForm();
                    this.$refs.partNameInput.focus();

                  }
                } else {
                  this.$message({
                    type: "error",
                    message: "Səhv əməliyyat",
                  });
                }
              }
            );
          } else {
            UpdateSparePart(spare).then((response) => {
              this.spareLoading = false;
              if (response.data.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: "Səhv əməliyyat",
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "Uğurlu əməliyyat",
                  });
                  this.getSpareParts();
                  this.resetSpareForm();
                }
              } else {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              }
            });
          }
        }
      });
    },

    handleCommandSpare(command) {
      let row = command.row;
      if (command.action === "delete") this.handleSpareDelete(row.id);
      else if (command.action === "edit") this.handleSpareEdit(row);
    },
    handleSpareEdit(row) {
      this.type = 2;
      this.spareItem.id = row.id
      this.spareItem.partName = row.partName
      this.spareItem.price = row.price
    },
    handleSpareDelete(id) {
      this.$confirm("Ehtiyyat hissəsi ləğv olunsun?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
        type: "error",
      })
        .then(() => {
          this.spareLoading = true;
          DeleteSparePart(id, this.value, this.uid, this.itemActType).then((response) => {
            this.spareLoading = false;
            if (response.data.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "Ləğv olundu",
                });
                this.getSpareParts();
              }
            } else {
              this.$message({
                type: "error",
                message: "Səhv əməliyyat",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Xitam verildi",
          });
        });
    },

  }, watch: {
    value() {
      this.claimId = this.value;
    },
    actType() {
      this.itemActType = this.actType;
    },
    policyType() {
      this.itemPolicyType = this.policyType;
      if (this.itemPolicyType === 1) {
      this.type = 2; 
    }
    },
    
  },



  mounted: function () {
    this.repairItem = new RepairStageType();
    this.spareItem = new SparePartType();
    this.updateTableData();
    this.getRepairStages();
    this.getSpareParts();
    this.getVictimParticipant();

  },

};
</script>

<style lang="scss"></style>